var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoChannels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#00aaff",
    strokeWidth: 0.696,
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6.5C17.5 7.05228 17.9477 7.5 18.5 7.5C19.0523 7.5 19.5 7.05228 19.5 6.5C19.5 5.94772 19.0523 5.5 18.5 5.5C17.9477 5.5 17.5 5.94772 17.5 6.5ZM18.5 8.5C17.3954 8.5 16.5 7.60457 16.5 6.5C16.5 5.39543 17.3954 4.5 18.5 4.5C19.6046 4.5 20.5 5.39543 20.5 6.5C20.5 7.60457 19.6046 8.5 18.5 8.5Z",
    fill: "#ff0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 7C3.5 8.38071 4.61929 9.5 6 9.5C6.38373 9.5 6.74727 9.41354 7.0722 9.25905C7.09262 9.29271 7.11737 9.32448 7.14645 9.35355L8.99591 11.203C8.68102 11.7283 8.5 12.343 8.5 13C8.5 14.933 10.067 16.5 12 16.5C12.3852 16.5 12.7559 16.4378 13.1025 16.3228L13.3669 16.8517C12.8433 17.2123 12.5 17.8161 12.5 18.5C12.5 19.6046 13.3954 20.5 14.5 20.5C15.6046 20.5 16.5 19.6046 16.5 18.5C16.5 17.3954 15.6046 16.5 14.5 16.5C14.4371 16.5 14.3749 16.5029 14.3134 16.5086L13.9966 15.875C14.9053 15.2428 15.5 14.1908 15.5 13C15.5 12.212 15.2396 11.4849 14.8002 10.8999C14.8188 10.8859 14.8366 10.8705 14.8536 10.8536L16.3536 9.35355C16.5488 9.15829 16.5488 8.84171 16.3536 8.64645C16.1583 8.45118 15.8417 8.45118 15.6464 8.64645L14.1464 10.1464C14.1295 10.1634 14.1141 10.1812 14.1001 10.1998C13.5151 9.76038 12.788 9.5 12 9.5C11.0862 9.5 10.2542 9.85021 9.63083 10.4237L7.8683 8.6612C8.26127 8.21956 8.5 7.63766 8.5 7C8.5 5.61929 7.38071 4.5 6 4.5C4.61929 4.5 3.5 5.61929 3.5 7ZM6 8.5C5.17157 8.5 4.5 7.82843 4.5 7C4.5 6.17157 5.17157 5.5 6 5.5C6.82843 5.5 7.5 6.17157 7.5 7C7.5 7.82843 6.82843 8.5 6 8.5ZM14.5 19.5C13.9477 19.5 13.5 19.0523 13.5 18.5C13.5 17.9477 13.9477 17.5 14.5 17.5C15.0523 17.5 15.5 17.9477 15.5 18.5C15.5 19.0523 15.0523 19.5 14.5 19.5ZM12 15.5C10.6193 15.5 9.5 14.3807 9.5 13C9.5 11.6193 10.6193 10.5 12 10.5C13.3807 10.5 14.5 11.6193 14.5 13C14.5 14.3807 13.3807 15.5 12 15.5Z",
    fill: "#ff0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoChannels);
export default __webpack_public_path__ + "static/media/promo_channels.c5ee4833ba2c0bb3e7a251e353b4ad59.svg";
export { ForwardRef as ReactComponent };